import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, PrimaryBtn } from "@/components/site/shared";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { openGhost } from "@/components/site/GhostAI";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader overline="Questions & Answers" title="Frequently Asked Questions" />
      <section className="section-pad">
        <div className="max-w-3xl mx-auto px-4">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-list">
            {faqs.map((f) => (
              <AccordionItem key={f.id} value={f.id} className="bg-white border border-gray-100 rounded-2xl px-5 card-shadow">
                <AccordionTrigger className="text-left font-semibold text-[var(--navy)] hover:no-underline">{f.question}</AccordionTrigger>
                <AccordionContent className="text-[var(--text-muted)] leading-relaxed">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <div className="mt-10 text-center bg-[var(--bg-light)] border border-gray-100 rounded-2xl p-8">
            <p className="text-[var(--text-muted)]">Still have questions?</p>
            <div className="flex flex-wrap justify-center gap-3 mt-4">
              <PrimaryBtn to="/get-a-quote">Get a Free Quote</PrimaryBtn>
              <button onClick={openGhost} className="btn-lift bg-[var(--navy)] text-white font-semibold px-6 py-3 rounded-full">Ask Ghost AI</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
